import * as z from "zod";

/** Served from the warehouse rather than the Contextual insights service. */
export const CONTEXTUAL_ATTRIBUTED_REVENUE_EVENT = "ctx_revenue";

export const getContextualMetric = {
  name: "getContextualMetric" as const,
  input: z.object({
    fromDate: z.string(),
    toDate: z.string(),
    event: z.string(),
    aggregate: z.enum(["SUM", "AVG", "UNIQUE"]),
    compareToPriorPeriod: z.boolean(),
  }),
  output: z.object({
    value: z.number(),
    comparisonChangePercent: z.number().optional(),
  }),
};
